'use es6';

const DEFAULTS = {
  interval: 2000,
  respProp: 'status',
  success: 'COMPLETE',
  failure: 'FAILED',
  onPoll: () => {},
  onSuccess: () => {},
  onFailure: () => {},
  onError: () => {},
  getStatus: (resp, respProp) => resp[respProp]
};

const handlePollResp = (resp, options) => {
  const status = options.getStatus(resp, options.respProp);
  let stopPolling = false;
  options.onPoll(resp, status);

  if (status === options.success) {
    stopPolling = true;
    options.onSuccess(resp);
  } else if (status === options.failure) {
    stopPolling = true;
    options.onFailure(resp);
  }

  return stopPolling;
};

export const pollApi = (apiCall, data, pollSettings) => {
  return new Promise((resolve, reject) => {
    const settings = Object.assign({}, DEFAULTS, pollSettings);

    const doPoll = () => {
      let stopPolling = false;
      apiCall(data).then(response => {
        stopPolling = handlePollResp(response, settings);

        if (!stopPolling) {
          setTimeout(doPoll, settings.interval);
        } else {
          resolve(response);
        }
      }).catch(e => {
        settings.onError(e);
        reject(e);
      });
    };

    doPoll();
  });
};